import {sample} from "lodash/collection";

class AdvertSlots {
    /**
     * @type {number}
     */
    slotsInRowMobile = 2;

    /**
     * @type {number}
     */
    slotsInRowDesktop = 4;

    /**
     * @type {number}
     */
    searchSlotsTaken = 0;

    /**
     * @type {Array}
     */
    hardcodedAdverts = [];

    /**
     * @type {number}
     */
    hardcodedAdvertsSlotCount = 3;

    /**
     * @type {number}
     */
    rowsBetweenHardcodedAdverts = 2;

    /**
     * @type {number}
     */
    hardcodedAdvertSlotsTaken = 0;

    /**
     * @type {number|undefined}
     */
    slotsCountBeforeHardcodedAdverts = undefined;

    /**
     * @type {Array}
     */
    interstitialCmsAdverts = [];

    /**
     * @type {number}
     */
    interstitialCmsAdvertsSlotCount = 5;

    /**
     * @type {number}
     */
    rowsBetweenInterstitialCmsAdvertsDesktop = 1;

    /**
     * @type {number}
     */
    rowsBetweenInterstitialCmsAdvertsMobile = 2;

    /**
     * @type {number}
     */
    interstitialCmsAdvertsSlotsTaken = 0;

    /**
     * @type {number|undefined}
     */
    slotsCountBeforeInterstitialCmsAdvertsAdverts = undefined;

    /**
     * @type {boolean}
     */
    isDesktop = true;

    /**
     * @returns {void}
     */
    prepareSlots() {
        this.searchSlotsTaken = 0;

        this.slotsCountBeforeHardcodedAdverts = this.isDesktop
            ? (this.slotsInRowDesktop * this.rowsBetweenHardcodedAdverts)
            : (this.slotsInRowMobile * this.rowsBetweenHardcodedAdverts);
        this.hardcodedAdvertSlotsTaken = 0;

        this.slotsCountBeforeInterstitialCmsAdvertsAdverts = this.isDesktop
            ? (this.slotsInRowDesktop * this.rowsBetweenInterstitialCmsAdvertsDesktop)
            : (this.slotsInRowMobile * this.rowsBetweenInterstitialCmsAdvertsMobile);
        this.interstitialCmsAdvertsSlotsTaken = 0;
    }

    /**
     * @param {boolean} isDesktop
     */
    setIsDesktop(isDesktop) {
        this.isDesktop = isDesktop;
    }

    /**
     * @param {Array} interstitialCmsAdverts
     */
    setInterstitialCmsAdverts(interstitialCmsAdverts) {
        this.interstitialCmsAdverts = interstitialCmsAdverts;
    }

    /**
     * @param {Array} hardcodedAdverts
     */
    setHardcodedAdverts(hardcodedAdverts) {
        this.hardcodedAdverts = hardcodedAdverts;
    }

    /**
     * @returns {Object|undefined}
     */
    getInterstitialCmsAdvert() {
        if (this.interstitialCmsAdverts.length) {
            return this.interstitialCmsAdverts.pop();
        }

        return undefined;
    }

    /**
     * Get random element from array and remove it
     * @param array
     * @returns string
     */
    popRandom (array) {
        let i = (Math.random() * array.length) | 0
        return array.splice(i, 1)[0]
    }

    /**
     * @returns {Object|undefined}
     */
    getHardcodedAdvert() {
        return this.popRandom(this.hardcodedAdverts);
    }

    /**
     * @param {Array} renderingObject
     * @returns {Array}
     */
    insertFirstPageAdvert(renderingObject) {
        if (this.searchSlotsTaken % this.slotsCountBeforeInterstitialCmsAdvertsAdverts === 0) {
            const interstitialCmsAdvert = this.getInterstitialCmsAdvert();
            if (interstitialCmsAdvert) {
                renderingObject.push({isInterstitialCmsAdvert: true, interstitialCmsAdvert});
                this.interstitialCmsAdvertsSlotsTaken++;
            }
        }

        return renderingObject
    }

    /**
     * @param {Array} renderingObject
     * @returns {Array}
     */
    insertOtherThenFirstPageAdvert(renderingObject) {
        if (this.searchSlotsTaken % this.slotsCountBeforeHardcodedAdverts === 0) {
            const hardcodedAdvert = this.getHardcodedAdvert()
            if (hardcodedAdvert) {
                renderingObject.push({isHardcodedAdvert: true, hardcodedAdvert});
                this.hardcodedAdvertSlotsTaken++;
            }
        }

        return renderingObject
    }
}

export const advertSlots = new AdvertSlots();
